import type { FieldChoice } from "@smartsuite/types";
import { $t } from "../../utils/intl";
import { OTHER_OPTION_VALUE } from "./OtherOptionField";
import { texts as otherOptionFieldTexts } from "./OtherOptionField.texts";

export const translateOtherOption = (options: FieldChoice[]): FieldChoice[] => {
  return options.map((option) => {
    if (option.value === OTHER_OPTION_VALUE) {
      return { ...option, label: $t(otherOptionFieldTexts.other) };
    }

    return option;
  });
};
